export default {
	opened: 'Açılış',
	closed: 'Kapanış',
	store: 'Mağaza',
	worked: 'Çalışma',
	stopped: 'Durdurulmuş',
	'power-type': 'Yetki türü',
	'archive-store': 'Mağazayı Arşivle',
	'unarchive-a-store': 'Mağazayı Arşivleme iptali',
	'are-you-sure-you-want-to-archive-this-store': 'Bu Mağazyı arşivlemek istediğinizden emin misiniz?',
	'are-you-sure-you-want-to-unarchive-this-store': 'Bu depoyu arşivden çıkarmak istediğinizden emin misiniz?',
	'the-store-has-been-successfully-archived': 'Mağaza başarıyla arşivlendi',	
	'the-store-has-been-successfully-unarchived': 'Mağaza başarıyla arşivden çıkarıldı',
	'your-tax-report-results-will-be-affected': 'Vergi raporu sonuçlarınız etkilenecektir',
	alert: 'uyarı'
}